import { useAtom } from 'jotai';
import {
  selectDateModalStepAtom,
  toggleSelectDateModalAtom,
  infoSelectDateModalAtom
} from '../atoms';

const useSelectOrderDateModalV2 = () => {
  const [isShowSelectDateModal, setShowSelectDateModal] = useAtom(toggleSelectDateModalAtom);
  const [stepSelectDateModal, setStepSelectDateModal] = useAtom(selectDateModalStepAtom);
  const [infoSelectDateModal, setInfoSelectDateModal] = useAtom(infoSelectDateModalAtom);

  return {
    isOpen: isShowSelectDateModal,
    setShowModal: setShowSelectDateModal,
    step: stepSelectDateModal,
    setStep: setStepSelectDateModal,
    info: infoSelectDateModal,
    setInfo: setInfoSelectDateModal
  };
};

export default useSelectOrderDateModalV2;
